import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type EcoIconName =
  | 'web'
  | 'mobile'
  | 'software'
  | 'uiux'
  | 'marketing'
  | 'api'
  | 'cloud'
  | 'stack'
  | 'scalable'
  | 'delivery'
  | 'rocket'
  | 'nodes'
  | 'users'
  | 'growth'
  | 'discover'
  | 'design'
  | 'develop'
  | 'shield'
  | 'clock'
  | 'star';

@Component({
  selector: 'app-eco-icon',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container [ngSwitch]="name">
      <svg *ngSwitchCase="'web'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2.5" y="4" width="19" height="13" rx="2" />
        <path d="M2 20h20" /><path d="M6 8h5M6 11h8" />
      </svg>

      <svg *ngSwitchCase="'mobile'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <rect x="6.5" y="2.5" width="11" height="19" rx="2.5" />
        <path d="M10.5 5.5h3" /><path d="M11 18.5h2" />
      </svg>

      <svg *ngSwitchCase="'software'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="3.4" />
        <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.2 5.2l2.1 2.1M16.7 16.7l2.1 2.1M18.8 5.2l-2.1 2.1M7.3 16.7l-2.1 2.1" />
      </svg>

      <svg *ngSwitchCase="'uiux'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z" />
        <path d="M4 21h10" />
      </svg>

      <svg *ngSwitchCase="'marketing'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 10v4a1 1 0 0 0 1 1h3l6 4V5L7 9H4a1 1 0 0 0-1 1z" />
        <path d="M17.5 8.5a5 5 0 0 1 0 7" />
      </svg>

      <svg *ngSwitchCase="'api'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="17.5" cy="5.5" r="2.6" /><circle cx="17.5" cy="18.5" r="2.6" /><circle cx="6" cy="12" r="2.8" />
        <path d="m8.5 10.6 6.6-3.7M8.5 13.4l6.6 3.7" />
      </svg>

      <svg *ngSwitchCase="'cloud'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17.5 19a4.5 4.5 0 0 0 .5-8.97A6 6 0 0 0 6.2 9.5 4 4 0 0 0 6.5 19z" />
      </svg>

      <svg *ngSwitchCase="'stack'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="m12 3 9 4.5-9 4.5-9-4.5z" /><path d="m3 12 9 4.5 9-4.5" /><path d="m3 16.5 9 4.5 9-4.5" />
      </svg>

      <svg *ngSwitchCase="'scalable'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="m12 2.5 8.5 4.9v9.2L12 21.5 3.5 16.6V7.4z" />
        <path d="m3.5 7.4 8.5 4.9 8.5-4.9M12 12.3v9.2" />
      </svg>

      <svg *ngSwitchCase="'delivery'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="2.5" width="6" height="5" rx="1.4" />
        <rect x="2.5" y="16.5" width="6" height="5" rx="1.4" />
        <rect x="9" y="16.5" width="6" height="5" rx="1.4" />
        <rect x="15.5" y="16.5" width="6" height="5" rx="1.4" />
        <path d="M12 7.5v4.5M5.5 16.5V12h13v4.5M12 12v4.5" />
      </svg>

      <svg *ngSwitchCase="'rocket'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>

      <svg *ngSwitchCase="'nodes'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="18" cy="5" r="2.4" /><circle cx="18" cy="19" r="2.4" /><circle cx="5.5" cy="12" r="2.6" />
        <path d="m7.8 10.8 7.9-4.5M7.8 13.2l7.9 4.5" />
      </svg>

      <svg *ngSwitchCase="'users'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>

      <svg *ngSwitchCase="'growth'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 20V5" /><path d="M4 20h16" />
        <path d="M8 20v-5M12 20v-9M16 20v-4" /><path d="m8 11 4-4 3 3 4-5" /><path d="M19 5h2v2" />
      </svg>

      <svg *ngSwitchCase="'discover'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="10.5" cy="10.5" r="6.5" /><path d="m15.5 15.5 5 5" />
      </svg>

      <svg *ngSwitchCase="'design'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z" /><path d="M14 6l4 4" />
      </svg>

      <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="m8 6-6 6 6 6" /><path d="m16 6 6 6-6 6" />
      </svg>
      <svg *ngSwitchCase="'shield'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3 4.5 6v6c0 4.5 3.2 8.3 7.5 9.5 4.3-1.2 7.5-5 7.5-9.5V6z" />
        <path d="m9 12 2 2 4-4" />
      </svg>

      <svg *ngSwitchCase="'clock'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
      </svg>

      <svg *ngSwitchCase="'star'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.7l5.9-.8z" />
      </svg>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: grid;
        place-items: center;
      }
      svg {
        width: 100%;
        height: 100%;
        display: block;
      }
    `,
  ],
})
export class EcoIconComponent {
  @Input({ required: true }) name!: EcoIconName;
}
